import React from 'react';
import styles from './index.css';
const formatTime = (time, date) => {
    const minute = 1000 * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const month = day * 30;
    const year = month * 12;
    const now = new Date().getTime();
    const diffValue = now - time;
    if (diffValue < 0) {
        return '';
    }
    const yearC = diffValue / year;
    const monthC = diffValue / month;
    const weekC = diffValue / (7 * day);
    const dayC = diffValue / day;
    const hourC = diffValue / hour;
    const minC = diffValue / minute;
    let result = '';
    if (yearC > 3) {
        result = date;
    }
    else if (yearC > 1) {
        result = `${parseInt(yearC.toString())}年前`;
    }
    else if (monthC >= 1) {
        result = `${parseInt(monthC.toString())}月前`;
    }
    else if (weekC >= 1) {
        result = `${parseInt(weekC.toString())}周前`;
    }
    else if (dayC >= 1) {
        result = `${parseInt(dayC.toString())}天前`;
    }
    else if (hourC >= 1) {
        result = `${parseInt(hourC.toString())}小时前`;
    }
    else if (minC >= 1) {
        result = `${parseInt(minC.toString())}分钟前`;
    }
    else {
        result = '刚刚';
    }
    return result;
};
class HotListItem extends React.PureComponent {
    render() {
        const { content } = this.props;
        const date = `${content.year}-${content.date}-${content.time}`;
        const time = new Date(date).getTime();
        const ip_from = (content.ip_from || '').split(',');
        return (React.createElement("div", { className: styles.hotItem },
            React.createElement("div", { className: styles.title },
                React.createElement("p", { className: styles.userinfo },
                    React.createElement("img", { src: content.faceurl }),
                    React.createElement("span", { className: styles.uname }, content.uname),
                    React.createElement("span", { className: styles.uptimes }, content.uptimes || ''))),
            React.createElement("div", { className: styles.txt, dangerouslySetInnerHTML: { __html: content.contents || '' } }),
            React.createElement("div", { className: styles.message },
                React.createElement("span", { className: styles.address }, `${ip_from[0] || ''}${ip_from[1] || ''}`),
                React.createElement("span", { className: styles.commentTime }, formatTime(time, date)),
                React.createElement("span", { className: styles.rec }, "\u56DE\u590D"))));
    }
}
export default HotListItem;
